export const ncrSectionFromERPType = {
    BASIC_INFORMATION: 'basicInformation',
    REWORK_PROCESS_ROUTING: 'reworkProcessRouting',
};
